module.exports = __webpack_public_path__ + "img/default0.2b632fd6.jpg";